import { gql } from '@apollo/client';
import gqlClient from '../../../../../utils/apolloClient';

const insertSectionMutation = gql`
  mutation ($object: area_sections_insert_input!) {
    insert_area_sections_one(object: $object) {
      id
    }
  }
`;

export const createSection = async (variables: object) => {
  const res = await gqlClient.mutate<{
    insert_area_sections_one: {
      id: string,
    }
  }>({ mutation: insertSectionMutation!, variables });
  return res.data?.insert_area_sections_one.id;
}
